import React from 'react';
import styled from '../../theme/styled';

import logo from '../../images/logo.svg';
import background from '../../images/svg-backgrounds/logotypebg.svg';

const LogoContainer = styled.div`
position: relative;
width: 100%;
height: calc(75vh + 1px);
background: url(${background});
z-index: 10;
.inner-logo-container {
    height: 100%;
    width:50%;
    display: flex;
    #logotype {
        width: 60%;
        align-self: center;
        margin: auto;
    }
}
@media only screen and (max-width: 1200px) {
    height: auto;
    background: none;
    padding: 50px 0 0 0;
    .inner-logo-container {
        width: 200px;
        height: 200px;
        background: ${props => props.theme.colors.dark[1]};
        margin: auto;
        border-radius: 9999px;
    }
    #logotype {
        width: 80%;
    }
}
`;

function Logo() {
    return <img id="logotype" src={logo} alt="logo"/>;
}

export const MainLogotypeContainer = () => {
    return (<LogoContainer>
        <div className="inner-logo-container">
            <Logo/>
        </div>
    </LogoContainer>);
};


// WEBPACK FOOTER //
// ./src/components/base/Logotype.tsx